export const calculateDateRanges = () => {
    const today = new Date().toISOString().split("T")[0];

    const hundredYearsAgo = new Date();
    hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
    const minDate = hundredYearsAgo.toISOString().split("T")[0];

    const todayDate = new Date();
    const futureDate = new Date();
    futureDate.setMonth(todayDate.getMonth() + 3);
    if (futureDate.getMonth() < todayDate.getMonth()) {
        futureDate.setFullYear(todayDate.getFullYear() + 1);
    }
    const maxDate = futureDate.toISOString().split("T")[0];

    const minDOBDate = new Date();
    minDOBDate.setFullYear(todayDate.getFullYear() - 18);
    const maxDOB = minDOBDate.toISOString().split("T")[0];

    return { today, minDate, maxDate, maxDOB };
};
